export default "__VITE_ASSET__Dtlu54Dm__"